import type { User } from 'firebase/auth';
import type { GetTutorWishlistsParams, GetTutorsParams, ProfileData } from '@/types/api';

const normalizeWishlistParams = (params?: GetTutorWishlistsParams) => ({
  page: params?.page ?? 1,
  limit: params?.limit ?? 10,
  includeProfile: params?.includeProfile ?? false,
});

export const getViewerIdentity = (
  firebaseUser: User | null,
  profile: ProfileData | null
) => {
  if (!firebaseUser) {
    return 'anonymous';
  }

  return `${profile?.role ?? 'authenticated'}:${firebaseUser.uid}`;
};

export const tutorQueryKeys = {
  all: (viewerIdentity: string) => ['tutors', viewerIdentity] as const,
  list: (viewerIdentity: string, params?: GetTutorsParams) =>
    ['tutors', viewerIdentity, params ?? {}] as const,
  detail: (viewerIdentity: string, tutorId: string | undefined) =>
    ['tutor', viewerIdentity, tutorId] as const,
};

export const wishlistTutorQueryKeys = {
  all: (viewerIdentity: string) => ['wishlistTutors', viewerIdentity] as const,
  list: (viewerIdentity: string, params?: GetTutorWishlistsParams) =>
    ['wishlistTutors', viewerIdentity, normalizeWishlistParams(params)] as const,
  caseOptions: (viewerIdentity: string, tutorId: string | undefined) =>
    ['wishlistTutorCaseOptions', viewerIdentity, tutorId] as const,
};

export const tutorWishlistMutationKey = (viewerIdentity: string) =>
  ['setTutorWishlist', viewerIdentity] as const;
